import * as React from 'react';
import styled from 'styled-components';
const StyleDiv = styled.div ``;
class IconRemove extends React.Component {
    render() {
        return (React.createElement(StyleDiv, { className: this.props.className },
            React.createElement("svg", { onClick: this.props.clicked, width: this.props.width, height: this.props.height, viewBox: "0 0 510 510" },
                React.createElement("g", null,
                    React.createElement("g", { id: "remove-circle" },
                        React.createElement("path", { d: "M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M382.5,280.5h-255v-51h255V280.5z    " }))))));
    }
}
;
export default IconRemove;
//# sourceMappingURL=IconRemove.js.map


// WEBPACK FOOTER //
// ./src/components/IconRemove.js